module.exports = {
  ImageData: () => {
    return {
      "arquitectonica" : 
        [
          {
            "id": "SSC9258",
            "name" : "Bodega San Carlos. Bogotá, Cundinamarca.",
            "desc" : "",
            "image": require("../assets/images/CubiertaArquitectonica/_SSC9258.webp"),
            "active" : true
          },
          {
            "id": "SSC9280",
            "name" : "Bodega San Carlos, vista aérea. Bogotá, Cundinamarca.",
            "desc" : "",
            "image": require("../assets/images/CubiertaArquitectonica/_SSC9280.webp"),
            "active" : true
          },
          {
            "id": "CasaArquitectonica",
            "name" : "Cada modelo con Cubierta Arquitectónica (Render)",
            "desc" : "",
            "image": require("../assets/images/CubiertaArquitectonica/06_CasaE3_T_Arquitectónicav30.2.webp"),
            "active" : true
          },
          {
            "id": "CasaTeja",
            "name" : "Cada modelo con Cubierta Arquitectónica. Render.",
            "desc" : "",
            "image": require("../assets/images/CubiertaArquitectonica/07_CasaE5_T_TejaArq0.2.webp"),
            "active" : true
          },
          {
            "id": "Agrobetania",
            "name" : "Agrobetanía. Bogotá, Cundinamarca.",
            "desc" : "",
            "image": require("../assets/images/CubiertaArquitectonica/Agrobetania.webp"),
            "active" : true
          },
          {
            "id": "Agrobetania2",
            "name" : "Agrobetanía. Bogotá, Cundinamarca.",
            "desc" : "",
            "image": require("../assets/images/CubiertaArquitectonica/Agrobetania2.webp"),
            "active" : true
          },
          {
            "id": "ConjuntoCasasBuga2",
            "name" : "Conjunto de casas Buga. Guadalajara de Buga, Valle del Cauca.",
            "desc" : "",
            "image": require("../assets/images/CubiertaArquitectonica/ConjuntocasasBuga2.webp"),
            "active" : true
          },
          {
            "id": "CubiertaArquitectonica",
            "name" : "Bodega San Carlos. Bogotá, Cundinamarca.",
            "desc" : "",
            "image": require("../assets/images/CubiertaArquitectonica/CubiertaArquitectonicaAcesco6.webp"),
            "active" : true
          },
        ]
      ,
      "master1000" : 
        [
          {
            "id": "CCElTersoroMedellín",
            "name" : "Centro Comercial El Tesoro. Medellín, Antioquia.",
            "desc" : "",
            "image": require("../assets/images/CubiertaMaster1000/CCElTersoro-Medellín.webp"),
            "active" : true
          },
          {
            "id": "DSC_0252",
            "name" : "Centro Comercial Palmetto Plaza. Cali, Valle del Cauca.",
            "desc" : "",
            "image": require("../assets/images/CubiertaMaster1000/DSC_0252.webp"),
            "active" : true
          },
          {
            "id": "Galvaceros",
            "name" : "Bodega Galvaceros. Girardota, Antioquia.",
            "desc" : "",
            "image": require("../assets/images/CubiertaMaster1000/Galvaceros.webp"),
            "active" : true
          },
          {
            "id": "Galvaceros2",
            "name" : "Bodega Galvaceros. Girardota, Antioquia.",
            "desc" : "",
            "image": require("../assets/images/CubiertaMaster1000/Galvaceros2.webp"),
            "active" : true
          },
          {
            "id": "ParqueaderoPortaldelaLoma",
            "name" : "Parqueadero Conjunto Residencial Portal de la Loma. Piedecuesta, Santander.",
            "desc" : "",
            "image": require("../assets/images/CubiertaMaster1000/PARQUEADEROPORTALDELALOMA-Piedec.webp"),
            "active" : true
          },
          {
            "id": "ParqueaderoPortaldelaLoma2",
            "name" : "Parqueadero Conjunto Residencial Portal de la Loma. Piedecuesta, Santander.",
            "desc" : "",
            "image": require("../assets/images/CubiertaMaster1000/PARQUEADEROPORTALDELALOMA-Piedecuesta2.webp"),
            "active" : true
          },
          {
            "id": "ParqueaderoPortaldelaLoma3",
            "name" : "Parqueadero Conjunto Residencial Portal de la Loma. Piedecuesta, Santander.",
            "desc" : "",
            "image": require("../assets/images/CubiertaMaster1000/PARQUEADEROPORTALDELALOMA-Piedecu.webp"),
            "active" : true
          },
          {
            "id": "PinturasBler",
            "name" : "Bodega Pinturas Bler. Cota, Cundinamarca",
            "desc" : "",
            "image": require("../assets/images/CubiertaMaster1000/PinturasBler.webp"),
            "active" : true
          },
          {
            "id": "PinturasBler2",
            "name" : "Bodega Pinturas Bler. Cota, Cundinamarca",
            "desc" : "",
            "image": require("../assets/images/CubiertaMaster1000/PinturasBler2.webp"),
            "active" : true
          },
        ]
      ,
      "sintraslapo" : 
        [
          {
            "id": "BodegaLaEsmeralda",
            "name" : "Bodega La Esmeralda. Girón, Santander.",
            "desc" : "",
            "image": require("../assets/images/TejaSinTraslapo/BodegaLaEsmeralda.webp"),
            "active" : true
          },
          {
            "id": "CabañasLosNieblosIntechos",
            "name" : "Cabaña Los Nieblos - Juan Manuel Gómez (Proyecto de Intechos). Pereira, Risaralda.",
            "desc" : "",
            "image": require("../assets/images/TejaSinTraslapo/CabañasLosNieblos-Intechos.webp"),
            "active" : true
          },
          {
            "id": "CabañaLosNieblos2Intechos",
            "name" : "Cabaña Los Nieblos - Juan Manuel Gómez (Proyecto de Intechos). Pereira, Risaralda.",
            "desc" : "",
            "image": require("../assets/images/TejaSinTraslapo/CabañaLosNieblos2-Intechos.webp"),
            "active" : true
          },
          {
            "id": "CasaCarlosGonzález",
            "name" : "Casa Carlos González. Villavicencio, Meta.",
            "desc" : "",
            "image": require("../assets/images/TejaSinTraslapo/CasaCarlosGonzález.webp"),
            "active" : true
          },
          {
            "id": "CasaMarthaMcallister",
            "name" : "Casa Martha Mcallister. Villavicencio, Meta.",
            "desc" : "",
            "image": require("../assets/images/TejaSinTraslapo/CasaMarthaMcallister.webp"),
            "active" : true
          },
          {
            "id": "Casasdellago",
            "name" : "Casas del Lago. Jamundí, Valle del Cauca.",
            "desc" : "",
            "image": require("../assets/images/TejaSinTraslapo/Casasdellago.webp"),
            "active" : true
          },
          {
            "id": "CasasTaquaraIntechos",
            "name" : "Casa Condominio Taquara (Proyecto de Intechos). Pereira, Risaralda",
            "desc" : "",
            "image": require("../assets/images/TejaSinTraslapo/CasasTaquara-Intechos.webp"),
            "active" : true
          },
          {
            "id": "CentroComercialPalmettoPlaza",
            "name" : "Centro Comercial Palmetto Plaza. Cali, Valle del Cauca.",
            "desc" : "",
            "image": require("../assets/images/TejaSinTraslapo/CentroComercialPalmettoPlaza.webp"),
            "active" : true
          },
          {
            "id": "ColegioBosquedePalma",
            "name" : "Colegio Bosque de Palma. Villavicencio, Meta.",
            "desc" : "",
            "image": require("../assets/images/TejaSinTraslapo/ColegioBosquedePalma.webp"),
            "active" : true
          },
          {
            "id": "EstadiodeBaseballEdgarRentería",
            "name" : "Estadio de Baseball Edgar Rentería. Barranquilla, Colombia",
            "desc" : "",
            "image": require("../assets/images/TejaSinTraslapo/EstadiodeBaseballEdgarRentería.webp"),
            "active" : true
          },
          {
            "id": "EstadioModernoJulioTorres",
            "name" : "Estadio Moderno Julio Torres. Barranquilla, Colombia.",
            "desc" : "",
            "image": require("../assets/images/TejaSinTraslapo/EstadioModernoJulioTorres.webp"),
            "active" : true
          },
          {
            "id": "EstadioReyPeléVillavicencio",
            "name" : "Estadio Rey Pelé. Villavicencio, Meta.",
            "desc" : "",
            "image": require("../assets/images/TejaSinTraslapo/EstadioReyPelé-Villavicencio.webp"),
            "active" : true
          },
          {
            "id": "Icoharinas1",
            "name" : "Bodegas Icoharinas. Girón, Santander.",
            "desc" : "",
            "image": require("../assets/images/TejaSinTraslapo/Icoharinas1.webp"),
            "active" : true
          },
          {
            "id": "Icoharinas2",
            "name" : "Bodegas Icoharinas. Girón, Santander.",
            "desc" : "",
            "image": require("../assets/images/TejaSinTraslapo/Icoharinas2.webp"),
            "active" : true
          },
          {
            "id": "OficinasFerrasa",
            "name" : "Oficinas Ferrasa. Medellín, Antioquia",
            "desc" : "",
            "image": require("../assets/images/TejaSinTraslapo/OficinasFerrasa.webp"),
            "active" : true
          },
          {
            "id": "PlantaKimberly",
            "name" : "Planta Kimberly. Puerto Tejada, Cauca.",
            "desc" : "",
            "image": require("../assets/images/TejaSinTraslapo/PlantaKimberly.webp"),
            "active" : true
          },
        ]
      ,
      "canaleta" : 
        [
          {
            "id": "Galvaceros1",
            "name" : "Bodega Galvaceros. Girardota, Antioquia.",
            "desc" : "",
            "image": require("../assets/images/Canaleta/Galvaceros_3.webp"),
            "active" : true
          },
          {
            "id": "Galvaceros1",
            "name" : "Bodega Galvaceros. Girardota, Antioquia.",
            "desc" : "",
            "image": require("../assets/images/Canaleta/Galvaceros_4.webp"),
            "active" : true
          },
          {
            "id": "ParqueIndustrialMilano",
            "name" : "Parque Industrial Milano. Mosquera, Cundinamarca",
            "desc" : "",
            "image": require("../assets/images/Canaleta/ParqueIndustrialMilano.webp"),
            "active" : true
          },
          {
            "id": "ParqueIndustrialMilano2",
            "name" : "Parque Industrial Milano. Mosquera, Cundinamarca",
            "desc" : "",
            "image": require("../assets/images/Canaleta/ParqueIndustrialMilano2.webp"),
            "active" : true
          },
        ]
      ,
      "metaldeck" : 
        [
          {
            "id": "CasaAcescoProvidencia",
            "name" : "Casa Acesco. Isla de Providencia, Colombia.",
            "desc" : "",
            "image": require("../assets/images/Metaldeck/CasaAcesco-Providencia.webp"),
            "active" : true
          },
          {
            "id": "ConjuntoTorresdeMálagaPasto",
            "name" : "Conjunto Torres de Málaga. Pasto, Nariño",
            "desc" : "",
            "image": require("../assets/images/Metaldeck/ConjuntoTorresdeMálaga-Pasto.webp"),
            "active" : true
          },
          {
            "id": "EdificioMilenio",
            "name" : "Edificio Milenio. Medellín, Antioquia",
            "desc" : "",
            "image": require("../assets/images/Metaldeck/EdificioMilenio.webp"),
            "active" : true
          },
          {
            "id": "EdificioRoseStreet",
            "name" : "Edificio Rose Street. Medellín, Antioquia",
            "desc" : "",
            "image": require("../assets/images/Metaldeck/EdificioRoseStreet.webp"),
            "active" : true
          },
          {
            "id": "EstahlIngenieríaOficinas",
            "name" : "Oficinas ESTAHL INGENIERIAS. Bogotá, Cundinamarca",
            "desc" : "",
            "image": require("../assets/images/Metaldeck/EstahlIngenieríaOficinas.webp"),
            "active" : true
          },
          {
            "id": "FerrasaOficinasMedellín",
            "name" : "Oficinas Ferrasa. Medellín, Antioquia",
            "desc" : "",
            "image": require("../assets/images/Metaldeck/FerrasaOficinas-Medellín.webp"),
            "active" : true
          },
          {
            "id": "GalvacerosOficinas",
            "name" : "Oficinas Galvaceros. Girardota, Antioquia.",
            "desc" : "",
            "image": require("../assets/images/Metaldeck/GalvacerosOficinas.webp"),
            "active" : true
          },
          {
            "id": "OficinasArquitectoCadavid",
            "name" : "Oficina Arquitectos Cadavid. Cali, Valle del Cauca.",
            "desc" : "",
            "image": require("../assets/images/Metaldeck/OficinasArquitectoCadavid.webp"),
            "active" : true
          },
          {
            "id": "OficinasArquitectoCadavid2",
            "name" : "Oficina Arquitectos Cadavid. Cali, Valle del Cauca.",
            "desc" : "",
            "image": require("../assets/images/Metaldeck/OficinasArquitectoCadavid2.webp"),
            "active" : true
          },
          {
            "id": "CentroComercialElCacique",
            "name" : "Parqueadero Centro Comercial El Cacique. Bucaramanga, Santander.",
            "desc" : "",
            "image": require("../assets/images/Metaldeck/ParqueaderoCentroComercialElCacique-Bmanga.webp"),
            "active" : true
          },
          {
            "id": "PlazaMayorPabellónVerde",
            "name" : "Centro de convenciones Plaza Mayor, Pabellón Verde. Medellín, Antioquia",
            "desc" : "",
            "image": require("../assets/images/Metaldeck/PlazaMayorPabellónVerde-Medellín.webp"),
            "active" : true
          },
          {
            "id": "TorreControlAeropuertoOlayaHerrera",
            "name" : "Torre de control, Aeropuerto Olaya Herrera. Medellín, Antioquia.",
            "desc" : "",
            "image": require("../assets/images/Metaldeck/TorreControlAeropuertoOlayaHerrera-Medellín.webp"),
            "active" : true
          },
          {
            "id": "UniversidaddelaSabana",
            "name" : "Universidad de la Sabana. Bogotá, Cundinamarca.",
            "desc" : "",
            "image": require("../assets/images/Metaldeck/UniversidaddelaSabana.webp"),
            "active" : true
          },
          {
            "id": "ViaductodelGranManglar",
            "name" : "Viaducto del Gran Manglar. Cartagena, Bolivar",
            "desc" : "",
            "image": require("../assets/images/Metaldeck/ViaductodelGranManglar.webp"),
            "active" : true
          },
          {
            "id": "ViaductodelGranManglar2",
            "name" : "Viaducto del Gran Manglar. Cartagena, Bolivar",
            "desc" : "",
            "image": require("../assets/images/Metaldeck/ViaductodelGranManglar2.webp"),
            "active" : true
          },
          {
            "id": "PuenteCCMayorca",
            "name" : "Puente CC Mayorca",
            "desc" : "",
            "image": require("../assets/images/Metaldeck/PuenteCCMayorca-Medellín.webp"),
            "active" : false
          },
        ]
      ,
    }
  }
}